@import '../../../global/variables.scss';

/**
* Exposed CSS variables
* @prop --nav-font-family: The font size of the nav item
* @prop --nav-item-gap: The space between nav-item elements when active
* @prop --nav-bg-color: The background color of the navbar
*/

@mixin center {
  display: flex;
  align-items: center;
  justify-content: center;
}

:host {
  display: block;
  background: var(--nav-bg-color, $light-700);
  font-family: var(--nav-font-family, $base-font-family);
}

main {
  padding: $size-2 calc($size-2 * 2);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
  grid-auto-rows: min-content !important;

  @include md {
    padding: $size-2 calc($size-2 + 0.25rem);
  }
  @include sm {
    padding: $size-2 calc($size-2 - 0.375rem);
  }

  &.layout-nav-items-center {
    section {
      grid-column: 2/4;
      grid-row: 1;
      gap: var(--nav-item-gap, $size-4);
      @include center;
    }
    ::slotted([slot='logo']) {
      grid-column: 1/2;
      grid-row: 1;
      @include center;
    }
    ::slotted([slot='search']) {
      grid-column: 4/5;
      grid-row: 1;
      @include center;
    }
  }
  &.layout-nav-items-right {
    section {
      grid-column: 3/5;
      grid-row: 1;
      gap: var(--nav-item-gap, $size-4);
      @include center;
    }
    ::slotted([slot='logo']) {
      grid-column: 1/2;
      grid-row: 1;
      @include center;
    }
    ::slotted([slot='search']) {
      grid-column: 2/3;
      grid-row: 1;
      @include center;
    }
  }
  &.layout-nav-items-left {
    section {
      grid-column: 1/3;
      grid-row: 1;
      gap: var(--nav-item-gap, $size-4);
      @include center;
    }
    ::slotted([slot='logo']) {
      grid-column: 3/4;
      grid-row: 1;
      @include center;
    }
    ::slotted([slot='search']) {
      grid-column: 4/5;
      grid-row: 1;
      @include center;
    }
  }
}

main {
  ::slotted([slot='logo']:focus-visible) {
    @include focus;
    border-radius: 0.125rem;
  }
  ::slotted([slot='search']:focus-visible) {
    @include focus;
    border-radius: 0.125rem;
  }
}
